// extracted by mini-css-extract-plugin
module.exports =  {"message":"vQ3qv2q8cU2zC5Y9ETHR","error":"kbw7mKDrGS89XOYVObb5","success":"aROFvs77NvwdifEOeJgw","btn":"uAqQCFphaKiFjbvgm2fD"};